










































































































































































































































import Vue from "vue";
import moment from "moment";
import { mapGetters } from "vuex";

// Model
import { Configuration, TimeBands } from "@/model/data/security/Configuration";
import { ClientPrivileges } from "@/model/data/authentication/ClientPrivilegesEnum";
import { TimeBandFlagsEnum } from "@/model/data/enums/TimeBandFlagEnum";
import VFaIcon from "@/components/VFaIcon.vue";

export default Vue.extend({
    components: { VFaIcon },
    props: {
        configuration: { type: Object as () => Configuration, required: true },
        editMode: Boolean,
        loading: Boolean,
    },
    data() {
        return {
            localConfiguration: null,
            days: [
                this.$t("common.dayOfWeek.monday"),
                this.$t("common.dayOfWeek.tuesday"),
                this.$t("common.dayOfWeek.wednesday"),
                this.$t("common.dayOfWeek.thursday"),
                this.$t("common.dayOfWeek.friday"),
                this.$t("common.dayOfWeek.saturday"),
                this.$t("common.dayOfWeek.sunday"),
            ],
            showTimeBandsDialog: false,
            colors: [
                "#008ffb",
                "#00e396",
                "#ff4560",
                "#feb019",
                "#775DD0",
                "#D7263D",
                "#4CAF50",
                "#3F51B5",
                "#F9CE1D",
                "#33B2DF",
                "#FF9800",
                "#546E7A",
                "#D4526E",
                "#13D8AA",
                "#A5978B",
                "#4ECDC4",
                "#81D4FA",
                "#5653FE",
                "#FD6A6A",
                "#2B908F",
                "#D7263D",
            ],
            pickerStartTime: "00:00",
            pickerEndTime: "23:59",
            startDay: null,
            endDay: null,
            fromEdit: false,
            options: 0,
            deviceItems: [
                { value: TimeBandFlagsEnum.OperatingMachine, text: this.$t("security_management.operatingMachine") },
                { value: TimeBandFlagsEnum.OnlyDeposit, text: this.$t("security_management.onlyDeposit") },
                { value: TimeBandFlagsEnum.None, text: this.$t("security_management.notOperatingMachine") },
            ],
            emptyOutItems: [
                { value: TimeBandFlagsEnum.EmptyoutPossible, text: this.$t("security_management.emptyoutPossible") },
                { value: TimeBandFlagsEnum.EmptyoutPossibleWithAlarm, text: this.$t("security_management.emptyoutPossibleWithAlarm") },
                { value: TimeBandFlagsEnum.None, text: this.$t("security_management.emptyoutNotPossible") },
            ],
            doorItems: [
                { value: TimeBandFlagsEnum.DoorOpen, text: this.$t("security_management.doorOpen") },
                { value: TimeBandFlagsEnum.DoorOpenWithAlarm, text: this.$t("security_management.doorOpenWithAlarm") },
                { value: TimeBandFlagsEnum.None, text: this.$t("security_management.doorNotOpen") },
            ],
            deviceOption: TimeBandFlagsEnum.None,
            doorOption: TimeBandFlagsEnum.None,
            emptyOutOption: TimeBandFlagsEnum.None,
            rerender: 0,
            timeBands: new Array<TimeBands>(),
            editIndex: 0,
        };
    },
    watch: {
        configuration: {
            handler(newValue: Configuration) {
                this.resetConfiguration(newValue);
            },
            immediate: true,
            deep: true,
        },
    },
    computed: {
        ...mapGetters(["authUserHasPrivilege", "userTimeFormat"]),

        canAdd() {
            if (!this.pickerStartTime || !this.pickerEndTime || this.pickerStartTime >= this.pickerEndTime) return false;
            if (this.startDay > this.endDay) return false;
            return true;
        },
        itemsStart() {
            let itemsStart = [
                { value: 0, text: this.$t("common.dayOfWeek.monday"), disabled: false },
                { value: 1, text: this.$t("common.dayOfWeek.tuesday"), disabled: false },
                { value: 2, text: this.$t("common.dayOfWeek.wednesday"), disabled: false },
                { value: 3, text: this.$t("common.dayOfWeek.thursday"), disabled: false },
                { value: 4, text: this.$t("common.dayOfWeek.friday"), disabled: false },
                { value: 5, text: this.$t("common.dayOfWeek.saturday"), disabled: false },
                { value: 6, text: this.$t("common.dayOfWeek.sunday"), disabled: false },
            ];
            for (let item of itemsStart) {
                if (item.value > this.endDay) item.disabled = true;
            }
            return itemsStart;
        },
        itemsEnd() {
            let itemsEnd = [
                { value: 0, text: this.$t("common.dayOfWeek.monday"), disabled: false },
                { value: 1, text: this.$t("common.dayOfWeek.tuesday"), disabled: false },
                { value: 2, text: this.$t("common.dayOfWeek.wednesday"), disabled: false },
                { value: 3, text: this.$t("common.dayOfWeek.thursday"), disabled: false },
                { value: 4, text: this.$t("common.dayOfWeek.friday"), disabled: false },
                { value: 5, text: this.$t("common.dayOfWeek.saturday"), disabled: false },
                { value: 6, text: this.$t("common.dayOfWeek.sunday"), disabled: false },
            ];
            for (let item of itemsEnd) {
                if (item.value < this.startDay) item.disabled = true;
            }
            return itemsEnd;
        },
        canWriteTimeBands() {
            return this.authUserHasPrivilege(ClientPrivileges.WriteBands);
        },
        timeBandStyles() {
            let styles = new Map<string, string>();
            let alreadyCreatedColor = new Map<TimeBandFlagsEnum, string>();
            for (let z = 0; z < this.timeBands.length; z++) {
                for (let indexHour = 1; indexHour <= 24; indexHour++) {
                    for (let indexDay = 1; indexDay <= 7; indexDay++) {
                        let timeBands = this.timeBands[z];
                        let startHour = parseInt(timeBands.startTime.substring(0, 2));
                        let endHour = parseInt(timeBands.endTime.substring(0, 2));
                        let startMinute = parseInt(timeBands.startTime.substring(3));
                        let endMinute = parseInt(timeBands.endTime.substring(3));
                        if (timeBands.startDay <= indexDay && indexDay <= timeBands.endDay && startHour <= indexHour - 1 && indexHour - 1 < endHour) {
                            let style = "";
                            let heightStart = (100 * startMinute) / 60;
                            let heightEnd = (100 * endMinute) / 60;
                            if (alreadyCreatedColor[timeBands.options] == undefined) alreadyCreatedColor[timeBands.options] = this.colors[z];
                            style = `cursor:inherit;position: relative;z-index: 100;background-color:${alreadyCreatedColor[timeBands.options]};`;

                            if (indexHour - 1 == startHour) style += `top: ${heightStart}%;width: 60%; height: ${103 - heightStart + heightEnd}%;`;
                            else if (indexHour == endHour) style += `width: 60%; height: ${103 + heightEnd}%;`;
                            else {
                                style += "width: 60%; height: 103%;";
                            }

                            style += "margin: 0 20% 0 20%;";
                            styles[`${indexDay} ${indexHour}`] = style;
                        }
                    }
                }
            }

            return styles;
        },
        timeBandTooltip() {
            let tooltips = new Map<string, string>();
            if (this.legend && this.legend.length) {
                for (let z = 0; z < this.timeBands.length; z++) {
                    for (let indexHour = 1; indexHour <= 24; indexHour++) {
                        for (let indexDay = 1; indexDay <= 7; indexDay++) {
                            let timeBands = this.timeBands[z];
                            let startHour = parseInt(timeBands.startTime.substring(0, 2));
                            let endHour = parseInt(timeBands.endTime.substring(0, 2));
                            if (timeBands.startDay <= indexDay && indexDay <= timeBands.endDay && startHour <= indexHour - 1 && indexHour - 1 < endHour) {
                                let tooltipOptions = this.legend.filter((l) => l.options == timeBands.options);
                                let tooltipOptionsLabel = "";
                                if (tooltipOptions && tooltipOptions.length == 1) tooltipOptionsLabel = tooltipOptions[0].label.join("\n");
                                tooltips[`${indexDay} ${indexHour}`] = `${timeBands.startTime} - ${timeBands.endTime}\n${tooltipOptionsLabel}`;
                            }
                        }
                    }
                }
            }
            return tooltips;
        },
        hours() {
            let hours = [""];
            for (let i = 0; i < 24; i++) {
                let hour = `${i}`.padStart(2, "0");
                hours.push(moment(`${hour}:00` as string, "HH:mm").format(this.userTimeFormat.timeFormat));
            }
            return hours;
        },
        legend() {
            let legend = [];
            let alreadyCreated: TimeBandFlagsEnum[] = [];

            for (let [index, timeBands] of this.timeBands.entries()) {
                if (alreadyCreated.indexOf(timeBands.options) == -1) {
                    let label = this.optionsToLabel(timeBands.options);
                    legend.push({ color: this.colors[index], label: label, options: timeBands.options });
                    alreadyCreated.push(timeBands.options);
                }
            }

            return legend;
        },
        pickerStartTimeFormatted() {
            if (this.pickerStartTime == null || this.pickerStartTime == undefined) return this.pickerStartTime;
            return moment(this.pickerStartTime, "HH:mm").format(this.userTimeFormat.timeFormat);
        },
        pickerEndTimeFormatted() {
            if (this.pickerEndTime == null || this.pickerEndTime == undefined) return this.pickerEndTime;
            return moment(this.pickerEndTime, "HH:mm").format(this.userTimeFormat.timeFormat);
        },
        collidingTimeBands() {
            if (this.showTimeBandsDialog && this.timeBands && this.endDay != null && this.startDay != null) {
                for (let j = 0; j < this.timeBands.length; j++) {
                    if (this.fromEdit && this.editIndex == j) continue;
                    let timeBand = this.timeBands[j];
                    for (let i = 0; i < timeBand.endDay - timeBand.startDay + 1; i++) {
                        let date = timeBand.startDay + i - 1;
                        if (this.startDay <= date && this.endDay >= date) {
                            let startHour = parseInt(timeBand.startTime.substring(0, 2));
                            let endHour = parseInt(timeBand.endTime.substring(0, 2));
                            let startMinute = parseInt(timeBand.startTime.substring(3, 6));
                            let endMinute = parseInt(timeBand.endTime.substring(3, 6));
                            let pickerStartHour = parseInt(this.pickerStartTime.substring(0, 2));
                            let pickerEndHour = parseInt(this.pickerEndTime.substring(0, 2));
                            let pickerStartMinute = parseInt(this.pickerStartTime.substring(3, 6));
                            let pickerEndMinute = parseInt(this.pickerEndTime.substring(3, 6));
                            if (pickerStartHour * 60 + pickerStartMinute < endHour * 60 + endMinute && startHour * 60 + startMinute < pickerEndHour * 60 + pickerEndMinute) {
                                return true;
                            }
                        }
                    }
                }
            }
            return false;
        },
    },
    methods: {
        resetConfiguration(configuration: Configuration) {
            this.localConfiguration = new Configuration();
            this.timeBands = new Array<TimeBands>();
            if (configuration) {
                this.localConfiguration.clone(configuration);
                if (this.localConfiguration && this.localConfiguration.timeBands) this.timeBands = this.localConfiguration.timeBands;
            }
        },
        colStyle(indexDay, indexHour) {
            let style = "";
            if (indexHour == 24 && indexDay > 0) style += "border-bottom: 1px solid #e0e0e0;";
            if (indexDay == 0) style += "border-top: 1px solid #e0e0e0;";
            else if (indexDay == 7) style += "border-right: 1px solid #e0e0e0; border-top: 1px solid #e0e0e0; border-left: 1px solid #e0e0e0;";
            else style += "border-top: 1px solid #e0e0e0; border-left: 1px solid #e0e0e0;";
            if (indexHour == 0) style = "";
            return style;
        },
        optionsToLabel(options: TimeBandFlagsEnum) {
            let label = [];
            if ((options & TimeBandFlagsEnum.OperatingMachine) != TimeBandFlagsEnum.None) label.push(this.$t("security_management.operatingMachine"));
            else if ((options & TimeBandFlagsEnum.OnlyDeposit) != TimeBandFlagsEnum.None) label.push(this.$t("security_management.onlyDeposit"));
            else label.push(this.$t("security_management.notOperatingMachine"));
            if ((options & TimeBandFlagsEnum.EmptyoutPossible) != TimeBandFlagsEnum.None) label.push(this.$t("security_management.emptyoutPossible"));
            else if ((options & TimeBandFlagsEnum.EmptyoutPossibleWithAlarm) != TimeBandFlagsEnum.None) label.push(this.$t("security_management.emptyoutPossibleWithAlarm"));
            else label.push(this.$t("security_management.emptyoutNotPossible"));
            if ((options & TimeBandFlagsEnum.DoorOpen) != TimeBandFlagsEnum.None) label.push(this.$t("security_management.doorOpen"));
            else if ((options & TimeBandFlagsEnum.DoorOpenWithAlarm) != TimeBandFlagsEnum.None) label.push(this.$t("security_management.doorOpenWithAlarm"));
            else label.push(this.$t("security_management.doorNotOpen"));
            return label;
        },
        addTimeBands(fromEdit) {
            let timeBand = new TimeBands();
            timeBand.startDay = this.startDay + 1;
            timeBand.endDay = this.endDay + 1;
            timeBand.startTime = this.pickerStartTime;
            timeBand.endTime = this.pickerEndTime;
            timeBand.options = this.deviceOption | this.doorOption | this.emptyOutOption;
            if (fromEdit) this.timeBands.splice(this.editIndex, 1, timeBand);
            else this.timeBands.push(timeBand);
            this.showTimeBandsDialog = false;
        },
        showEditTimeBandsDialog(index: number) {
            let timeband = this.timeBands[index];
            this.editIndex = index;
            this.pickerStartTime = timeband.startTime;
            this.pickerEndTime = timeband.endTime;
            this.startDay = timeband.startDay - 1;
            this.endDay = timeband.endDay - 1;
            this.fromEdit = true;
            if ((timeband.options & TimeBandFlagsEnum.OperatingMachine) != TimeBandFlagsEnum.None) this.deviceOption = TimeBandFlagsEnum.OperatingMachine;
            else if ((timeband.options & TimeBandFlagsEnum.OnlyDeposit) != TimeBandFlagsEnum.None) this.deviceOption = TimeBandFlagsEnum.OnlyDeposit;
            else this.deviceOption = TimeBandFlagsEnum.None;
            if ((timeband.options & TimeBandFlagsEnum.EmptyoutPossible) != TimeBandFlagsEnum.None) this.emptyOutOption = TimeBandFlagsEnum.EmptyoutPossible;
            else if ((timeband.options & TimeBandFlagsEnum.EmptyoutPossibleWithAlarm) != TimeBandFlagsEnum.None) this.emptyOutOption = TimeBandFlagsEnum.EmptyoutPossibleWithAlarm;
            else this.emptyOutOption = TimeBandFlagsEnum.None;
            if ((timeband.options & TimeBandFlagsEnum.DoorOpen) != TimeBandFlagsEnum.None) this.doorOption = TimeBandFlagsEnum.DoorOpen;
            else if ((timeband.options & TimeBandFlagsEnum.DoorOpenWithAlarm) != TimeBandFlagsEnum.None) this.doorOption = TimeBandFlagsEnum.DoorOpenWithAlarm;
            else this.doorOption = TimeBandFlagsEnum.None;
            this.showTimeBandsDialog = true;
        },
        showAddTimeBandsDialog(indexDay, indexHour) {
            if (indexDay != null && indexDay != undefined) {
                this.startDay = indexDay - 1;
                this.endDay = indexDay - 1;
            } else {
                this.startDay = 0;
                this.endDay = 0;
            }
            if (indexHour != null && indexHour != undefined) {
                this.pickerStartTime = `${(indexHour - 1).toString().padStart(2, "0")}:00`;
                this.pickerEndTime = `${indexHour.toString().padStart(2, "0")}:00`;
            } else {
                this.pickerStartTime = "07:00";
                this.pickerEndTime = "18:00";
            }

            this.fromEdit = false;
            this.deviceOption = TimeBandFlagsEnum.None;
            this.doorOption = TimeBandFlagsEnum.None;
            this.emptyOutOption = TimeBandFlagsEnum.None;
            this.showTimeBandsDialog = true;
        },
        deleteTimeBands(index: number) {
            this.timeBands.splice(index, 1);
            this.showTimeBandsDialog = false;
        },
        saveConfiguration() {
            if (!this.localConfiguration) this.localConfiguration = new Configuration();
            this.localConfiguration.timeBands = this.timeBands;

            return this.localConfiguration;
        },
        getTimeBandColor(index: number) {
            if (this.timeBands && this.timeBands.length && index < this.timeBands.length) {
                let timeBand = this.timeBands[index];
                if (timeBand && timeBand.options != null && timeBand.options != undefined) {
                    let legend = this.legend.filter((c) => c.options == timeBand.options);
                    if (legend && legend.length && legend[0].color) return legend[0].color;
                }
            }
            return "";
        },
        calendarEventClick(indexDay: number, indexHour: number) {
            if (!this.editMode || (this.editMode && !this.canWriteTimeBands)) return;
            let found = false;
            for (let i = 0; i < this.timeBands.length; i++) {
                let timeBands = this.timeBands[i];
                let startHour = parseInt(timeBands.startTime.substring(0, 2));
                let endHour = parseInt(timeBands.endTime.substring(0, 2));
                if (timeBands.startDay <= indexDay && indexDay <= timeBands.endDay && startHour <= indexHour - 1 && indexHour - 1 < endHour) {
                    this.showEditTimeBandsDialog(i);
                    found = true;
                }
            }
            if (!found) this.showAddTimeBandsDialog(indexDay, indexHour);
        },
    },
});
